import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { AuthService } from 'app/_services/auth.service';
import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import {
    FeatureTogglesResource,
    FeatureToggles
} from 'angular/resources/feature-toggles.resource';
import { config } from 'angular/utils/config';

type OperatorSettingsViewType =
    | 'general'
    | 'auctions'
    | 'secondary-trading'
    | 'surrender'
    | 'credit-limits';

class OperatorSettingsCtrl implements ng.IController {
    public enabledSettings: PossibleSettings[];
    private loginResult: LoginResult;
    public appBaseUrl = config.appBaseUrl;
    public balancingGroupPortfolioCodeSelection: BalancingGroupPortfolioCodeSelection;
    public activeSetting: OperatorSettingsViewType;
    public bgpc: any = {};
    public featureToggles: FeatureToggles;
    public settings: any = {
        general: {
            termsConditions: {
                enabled: false,
                title: '',
                content: ''
            },
            bgpc: {
                enabled: false,
                type: 'none',
                auctions: {
                    longterm: 'na',
                    shortterm: 'na'
                },
                secondary: {
                    longterm: 'na',
                    shortterm: 'na'
                },
                surrender: {
                    longterm: 'na',
                    shortterm: 'na'
                },
                fcfs: {
                    longterm: 'na',
                    shortterm: 'na'
                },
                reverse: {
                    flowCommitment: 'na',
                    buyBack: 'na'
                }
            },
            contractingServices: {
                enabled: false
            }
        },
        auctions: {},
        secondary: {
            allowOTC: true,
            allowFCFS: false,
            allowCFO: true,
            allowAssignment: false,
            enableAutomaticApprovalOfTrades: false,
            allowTransferOfUse: false,
            enableAutomaticApprovalOfTradesForTransferOfUse: false,
            allowAnonymousTrading: false,
            enablePricePublication: true,
            allowTraderListUsage: true,
            allowBundlingOfUnbundledContracts: false,
            enabled: false
        },
        surrender: {
            enabled: false
        },
        fcfs: {
            enabled: false
        },
        registration: {},
        creditLimits: {
            enabled: false
        }
    };

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private authService: AuthService,
        private growl: Growl,
        private $location: ng.ILocationService,
        private errorHandler: ErrorHandler,
        private featureTogglesResource: FeatureTogglesResource
    ) {}

    $onInit(): void {
        this.featureTogglesResource
            .getUrls()
            .subscribe(
                (featureToggles) => (this.featureToggles = featureToggles)
            );

        this.authService.userLoginPromise.promise
            .then(
                (loginResult: LoginResult) => {
                    this.loginResult = loginResult;

                    this.TransmissionSystemOperator.getEnabledSettings(
                        { id: this.loginResult.referenceId },
                        (enabledSettings: PossibleSettings[]) => {
                            this.enabledSettings = enabledSettings;
                        },
                        this.errorHandler
                    );

                    this.TransmissionSystemOperator.getBalancingGroupPortfolioCodeSelection(
                        { id: this.loginResult.referenceId },
                        (res) => {
                            this.balancingGroupPortfolioCodeSelection =
                                res.value;
                        },
                        this.errorHandler
                    );
                },
                (err: any) => {
                    this.growl.show(
                        'Whoops! Something went wrong. Please try again later',
                        'danger'
                    );
                }
            )
            .catch(() => {
                this.growl.show('Permission denied.', 'danger');
            });

        this.bgpc = {
            type: 'none'
        };

        if (!this.activeSetting) {
            this.activeSetting = 'general';
        }
    }

    public isActiveUrl(url) {
        return url === this.$location.path();
    }
}

angular.module('app').component('pkpOperatorSettings', {
    controller: OperatorSettingsCtrl,
    template: require('app/operator-settings/operator-settings.component.html'),
    bindings: {
        // settings: '=',
        activeSetting: '='
    }
});
